import { Component, OnInit } from '@angular/core';
import { DistanceAzimuthService } from '../services/distance-azimuth.service';

@Component({
  selector: 'app-distance-azimuth',
  templateUrl: './distance-azimuth.component.html',
  styleUrls: ['./distance-azimuth.component.scss'],
  standalone: false
})
export class DistanceAzimuthComponent implements OnInit {

  constructor(public distanceAzimuthService: DistanceAzimuthService) { }

  ngOnInit(): void {
  }



}
